var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSecureRemoteAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3069",
    "data-name": "Rectangle 3069",
    width: 24,
    height: 24,
    transform: "translate(16292 1488)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_secure_remote_access",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8904",
    "data-name": "Group 8904",
    transform: "translate(16292 1489.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices-svgrepo-com_3_",
    "data-name": "devices-svgrepo-com (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_251",
    "data-name": "Union 251",
    d: "M17.5,21.317H6.5a1.115,1.115,0,0,1-.121.007,1.062,1.062,0,0,1-1.052-.895,1.062,1.062,0,0,1,1.051-.9,1.012,1.012,0,0,1,.122.007H8.882V17.764H1.777A1.778,1.778,0,0,1,0,15.987V1.777A1.778,1.778,0,0,1,1.777,0H22.223A1.778,1.778,0,0,1,24,1.777V15.987a1.779,1.779,0,0,1-1.777,1.777H15.117v1.777H17.5a1.015,1.015,0,0,1,.122-.007,1.061,1.061,0,0,1,1.051.9,1.062,1.062,0,0,1-1.052.895A1.112,1.112,0,0,1,17.5,21.317Zm4.725-5.33V1.777H1.777V15.987H22.223Z",
    transform: "translate(0 0)",
    fill: "#003fb9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8905",
    "data-name": "Group 8905",
    transform: "translate(16298.75 1492.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_165",
    "data-name": "Subtraction 165",
    d: "M5.251,10.5A5.25,5.25,0,0,1,1.538,1.538,5.25,5.25,0,0,1,10.5,5.251,5.251,5.251,0,0,1,5.251,10.5ZM3.417,4.248l-.846.843L3.839,6.36,2.571,7.626l.846.843L5.528,6.36Zm3.619-1.81L4.925,4.549,7.036,6.661l.845-.845L6.613,4.549,7.881,3.283Z",
    fill: "#003fb9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecureRemoteAccess);
export default __webpack_public_path__ + "static/media/ic_secure_remote_access.a8897719f05798c9e62867b9333d277d.svg";
export { ForwardRef as ReactComponent };